var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOmnichannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.09 14.23c.09.05.18.07.28.07.1 0 .19-.02.28-.07l9.4-4.9c.2-.1.32-.31.32-.53 0-.22-.12-.43-.33-.53l-9.4-4.9a.594.594 0 00-.55 0l-9.4 4.9c-.2.1-.32.31-.32.53 0 .22.12.43.32.53l9.4 4.9zm.28-1.21L4.27 8.8l8.1-4.22 8.1 4.22-8.1 4.22zm-.28 4.41c.09.05.18.07.28.07.1 0 .19-.02.28-.08l9.4-4.9c.29-.15.4-.52.25-.81a.605.605 0 00-.81-.25l-9.12 4.76-9.12-4.75a.588.588 0 00-.81.25c-.15.3-.04.66.25.81l9.4 4.9zm.28 3.27c-.1 0-.19-.02-.28-.07l-9.4-4.9a.597.597 0 01-.25-.81c.15-.29.52-.41.81-.25l9.12 4.75 9.12-4.76c.29-.15.66-.04.81.25.15.29.04.66-.25.81l-9.4 4.9c-.09.06-.18.08-.28.08zm0-9.2c-.33 0-.6-.27-.6-.6V9.4h-1.5c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6h1.5V6.7c0-.33.27-.6.6-.6.33 0 .6.27.6.6v1.5h1.5c.33 0 .6.27.6.6 0 .33-.27.6-.6.6h-1.5v1.5c0 .33-.27.6-.6.6z"
  })));
}

export default SvgOmnichannel;